function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#949494;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "\u041C\u043E\u043D\u0442\u0430\u0436\u043D\u0430\u044F \u043E\u0431\u043B\u0430\u0441\u0442\u044C 1");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "\\u043F\\u0438\\u0442\\u0435\\u0440"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11"
}, /*#__PURE__*/React.createElement("path", {
  id: "horse",
  className: "cls-1",
  d: "M18.41,13.09a15.13,15.13,0,0,0-2.28-3.35q0-.69.09-5.4l-1-1q1-1.12.39-2.06a.86.86,0,0,0-1.18.1q-.45.44,0,1.79h-.84l-.41.48-.17,2.57h-.47a5.87,5.87,0,0,0-1.33-3.78h-.7a.89.89,0,0,1-.33-.85l-1,.85A23.75,23.75,0,0,0,6.8,4.56c-.25.34.2,1.09.63,1.09a1,1,0,0,0,.82-.44.86.86,0,0,1,1.41.23,3.4,3.4,0,0,1-1,1.77q-1.91,2-2,2.9a11.06,11.06,0,0,1-1.87.19L3,12.43v1.43l1.08,1.23.36-1.61-.65-.15-.11-.6L5.13,11.4H6.56l-.63,3.05.29,1,1.11.7.18-1.47H6.8L6.7,14l.89-2.12A9.76,9.76,0,0,0,11,14a6.25,6.25,0,0,0,.72,2.14,8.89,8.89,0,0,1,1,1.89l-1.56,1.38-1.24-.19-.62.94h2.11l2.39-1.89-.12-2.84H14a4.32,4.32,0,0,0,.79,2q.45.44,1.2,1.08l-.87,1.81-1-.14-.7,1,2.05-.08,1.64-2.79c0-.13-.62-1.59-.48-1.95a16.32,16.32,0,0,0,1.51-2.15q.64.08.83,1.26a14.31,14.31,0,0,0,.19,4A4,4,0,0,0,21.45,22l.72-.31a10.82,10.82,0,0,1-1.35-2.8c-.44-1.9-.44-3.72-.61-4.19A3.13,3.13,0,0,0,18.41,13.09Z"
})));

var SvgPiter = function SvgPiter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 26 24",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPiter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/piter.d6872218.svg";
export { ForwardRef as ReactComponent };